var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(13.170731707317072) translate(-2.394855287339949, -2.4444444444444438)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#363a3d"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,44.3L48,44.3c10.3,0,18.7-8.4,18.7-18.7C66.7,15.4,58.3,7,48,7c-10.3,0-18.7,8.4-18.7,18.7    C29.3,35.9,37.7,44.3,48,44.3z M48,13c7,0,12.7,5.7,12.7,12.7c0,7-5.7,12.7-12.7,12.7h0c-7,0-12.7-5.7-12.7-12.7    C35.3,18.7,41,13,48,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,43.3l-1.3-0.1l-1,0.9c-3.5,3.5-8.2,5.3-13.2,5.3s-9.6-1.9-13.2-5.3l-1-0.9l-1.3,0.1c-11.4,0.8-20.4,10.5-20.4,22V89    h71.7V65.3C83.9,53.8,74.9,44.2,63.5,43.3z M77.9,83H18.1V65.3c0-7.9,5.9-14.7,13.6-15.8c4.5,3.9,10.3,6.1,16.3,6.1    s11.8-2.1,16.3-6.1c7.7,1.2,13.6,7.9,13.6,15.8V83z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.6,66 58.6,69 55.6,72 59.8,76.3 67.1,69 59.8,61.7   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 66,
    transform: "matrix(0.2731 -0.962 0.962 0.2731 -31.208 96.6977)",
    width: 20.7,
    height: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.2,61.7 28.9,69 36.2,76.3 40.4,72 37.4,69 40.4,66   "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.dcf923086ab6ba79fa1548b06f181840.svg";
export { ForwardRef as ReactComponent };